const appointmentUpdateConstants = {
    UPDATE_APPOINTMENT_REQUEST: 'UPDATE_APPOINTMENT_REQUEST',
    UPDATE_APPOINTMENT_SUCCESS: 'UPDATE_APPOINTMENT_SUCCESS',
    UPDATE_APPOINTMENT_FAILURE: 'UPDATE_APPOINTMENT_FAILURE',
    UPDATE_APPOINTMENT_RESET: 'UPDATE_APPOINTMENT_RESET'
};

export default appointmentUpdateConstants;